<template>
  <div class="mailYtComponent">
    <keep-alive>
    <span class="end-selected-view" @click="handleOpen">{{endSelected[props.lable] ? endSelected[props.lable] : placeholder}}</span>
    </keep-alive>
    <!-- 多级选择 -->
    <div class="yt-multi-seletor" v-show="visible">
      <div class="yt-selected-view">
        <!-- 已选择列表 -->
        <div class="yt-selected-top-view">
          <div class="yt-selected-top-operate-view">
            <span class="yt-text" @click="handleClose">取消</span>
            <span class="yt-text" @click="handleConfirm">确认</span>
          </div>
          <div
            class="yt-district-item-view"
            v-for="(item, index) in selectedList" :key="index">
            <p class="yt-district-view"
              :class="{'yt-selectedView': (selectedNode.index == index && !selectLowerBtn),'yt-first': index == 0}"
              @click="handleSelect(index, item)">{{item[props.lable]}}</p>
              <!-- @@@{{index}}--{{selectedNode.index}}{{(selectedNode.index == index && !selectLowerBtn)}}++ {{selectLowerBtn}} -->
          </div>
          <div class="yt-district-item-view">
            <p class="yt-district-view yt-selectedView yt-showSelectSub" :class="{'yt-first': selectedList.length == 0}" v-show="selectLowerBtn">请选择下级部门</p>
          </div>
        </div>

        <div class="yt-selected-bottom-view">
          <p class="yt-selected-title-view">部门分组</p>
          <div class="yt-selected-scrollview">
            <p
              class="yt-cell-view"
              v-for="(item, index) in currentList"
              :key="index"
              @click="handleCurrent(item)">{{item[props.lable]}}{{item[props.children] ? '>' : ''}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let n = 0
export default {
  name: 'ceshi',
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    data: {
      type: Array,
      default: [],
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    props: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          value: 'value',
          parent_value: 'parent_value',
          lable: 'lable',
          children: 'children' 
        }
      }
    },
  },
  data () {
    return {
      visible: false,
      selectedList: [],
      selectedNode: {
        index: 0
      },
      selectLowerBtn: true,
      currentList: [],
      endSelected: {}
    }
  },
  computed: {

  },
  created () {
    this.getInitList()
    console.log('this', this.props)
  },
  methods: {
    // 获取当前默认初始列表
    getInitList () {
      if (this.value !== '') {
        this.selectedList = this.getParent(this.data, this.value)
        this.currentList = this.getNewCurrentList(this.data, this.selectedList[this.selectedList.length-1][this.props.parent_value])
        console.log('nowList', this.selectedList)
        console.log('currentList', this.currentList)
      }else {
        this.currentList = this.data
      }
      console.log('tag', this.currentList)
    },
    // 确认已选择部门信息
    handleConfirm () {
      console.log('确认已选择列表', this.selectedList)
      let length = this.selectedList.length
      if (length !== 0) {
        this.endSelected = this.selectedList[ length - 1]
        this.$emit('update:value', this.endSelected[this.props.value])
        this.$emit('confirm', {detail: this.selectedList, value: this.endSelected[this.props.value]})
        this.visible = false
      } else {
        this.$emit('confirm', {detail: this.selectedList})
      }
    },
    // 开启选择器
    handleOpen () {
      console.log('this.value', this.value)
      console.log('this.data', this.data)
      this.visible = true
      if (this.value !== '') {
        this.selectedList = this.getParent(this.data, this.value)
        this.currentList = this.getNewCurrentList(this.data, this.selectedList[this.selectedList.length-1][this.props.parent_value])
        console.log('nowList', this.selectedList)
        console.log('currentList', this.currentList)
      }
    },
    // 获取当前选择的所有父级信息
    getParent(data2, nodeId2) {
      var arrRes = [];
      if (data2.length == 0) {
          if (!!nodeId2) {
              arrRes.unshift(data2)
          }
          return arrRes;
      }
      let rev = (data, nodeId) => {
          for (var i = 0, length = data.length; i < length; i++) {
              let node = data[i];
              if (node[this.props.value] == nodeId) {
                  arrRes.unshift(node)
                  rev(data2, node[this.props.parent_value]);
                  break;
              }
              else {
                  if (!!node.children) {
                      rev(node.children, nodeId);
                  }
              }
          }
          return arrRes;
      };
      arrRes = rev(data2, nodeId2);
      return arrRes;
    },
    // 关闭选择器
    handleClose () {
      // 隐藏
      this.visible =  false
      // 重置所有数据
      this.selectedList = []
      this.selectedNode.index = 0
      this.selectLowerBtn = true,
      this.currentList = this.data
    },
    // 操作当前显示部门
    handleCurrent (item) {
      console.log('e', item)
      this.currentSelectNode = item
      let parent_value = this.props.parent_value
      let selectedList = [...this.selectedList]
      let length = selectedList.length
      // console.log('selectedList', selectedList.length)
      let isPush = true
      if (length == 0) { isPush = true }
      for (let i = 0; i < length; i++) {
        // console.log('selectedList[i][parent_value]', selectedList[i][parent_value])
        // console.log('item[parent_value]', item[parent_value])
        // console.log('isPush', isPush)
        if (selectedList[i][parent_value] == item[parent_value]) {
          // console.log('125', '')
          this.selectedList.splice(i, 1, item)
          isPush = false
        }
        // console.log('isPush', isPush)
      }
      // console.log('isPush', isPush)
      if (isPush) {
        this.selectedList.push(item)
      }
        if (item[this.props.children]){
          this.selectLowerBtn = true
          this.currentList = item[this.props.children]
          this.selectedNode.index = this.selectedNode.index + 1
        } else {
          this.selectLowerBtn = false
          this.selectedNode.index = this.selectedNode.index
        }
      
      console.log('this.selectedNode.index', this.selectedNode.index, this.selectLowerBtn)
      
    },
    // 操作当前已选择部门
    handleSelect (index, item) {
      console.log(index, item)
      let length = this.selectedList.length - 1
      this.selectedList.splice(index + 1, length - index)
      this.currentList = this.getNewCurrentList(this.data, item[this.props.parent_value])
      this.selectLowerBtn = item[this.props.children] ? true : false
      this.selectedNode = {
        index: index,
        item: item
      }
      console.log('当前列表', this.currentList)
    },
    // 获取新的部门列表显示
    getNewCurrentList (list, now_parent_id) {
      let vm = this
      for (let i in list) {
      // console.log('now_parent_id', now_parent_id, 'id', list[i]['id'])
        if (now_parent_id == undefined) {
          return list
        } else if (list[i]['id'] == now_parent_id) {
        console.log('list[i]', list[i])
          return list[i][this.props.children]
        } else {
          // 没找到，继续调用此函数
          return vm.getNewCurrentList(list[i][this.props.children], now_parent_id)
        }
      }
    }
  },
  watch: {
    // 监听选择器列表数据变化
    'data' (newVal, oldVal) {
      console.log('oldVal', oldVal)
      console.log('data改变', newVal, oldVal.length === 0 && newVal.length !== 0)
      if (oldVal.length === 0 && newVal.length !== 0) {
        this.getInitList()
      }
    },
    endSelected (newVal) {
      console.log('new endSelected', newVal)
    }
  }
}
</script>  


<style lang='less' scoped>
.mailYtComponent {
  .end-selected-view {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #333333;
    display: inline-block;
  }

  /* 层级选择 */
  .yt-multi-seletor{
    width: 100%;
    font-size: 18px;
    background-color: rgba(0, 0, 0, 0.6);
    /* background-color: rgb(148, 143, 143);filter:Alpha(Opacity=60);   opacity:0.6; */
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
  }

  .yt-selected-view {
    position: fixed;
    width: 50%;
    height: 50%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 190px auto;
    border-radius: 8px 8px 0 0;
    background-color: #fff;
  }

  .yt-selected-top-operate-view {
    /* // width: 100%; */
    padding: 0 10px;
    line-height: 50px;
    color: #1189f1;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    span {
      font-size: 0.34rem;
    }
  }

  .yt-district-item-view {
    padding-top: 7px;
    display: flex;
    padding: 0 10px;
    /* border-bottom: 1px #66CC99 solid; */
  }

  .yt-district-view {
    color: #333333;
    padding-left: 20px;
    height: 40px;
    line-height: 40px;
    position: relative;
    font-size: 0.3rem;
  }

  /* 线条 */
  .yt-district-view::before {
    display: block;
    content: '';
    width: 1px;
    height: 33px;
    background-color: #1189f1;
    position: absolute;
    left: 0;
    top: -16px;
  }

  /* 圆点 */
  .yt-district-view::after {
    display: block;
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: 1px solid #1189f1;
    background-color: #1189f1;
    position: absolute;
    left: -3px;
    top: 16px;
  }

  .yt-district-view.yt-first::before {
    display: none;
  }

  .yt-district-item-view:first-child .yt-district-view::before {
    display: none;
  }

  .yt-district-view.yt-showSelectSub::after {
    background-color: #ffffff !important;
  }

  /* 选中层级的颜色 */

  .yt-selectedView {
    color: #1189f1;
  }

  .yt-selected-bottom-view {
    background-color: whitesmoke;
    border-top: 1px solid #f0f0f0;
    text-align: left;
  }

  .yt-selected-title-view {
    text-indent: 10px;
    font-size: 15px;
    color: #a3a3a3;
    height: 40px;
    line-height: 40px;
  }

  .yt-selected-scrollview {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 190px;
    /* background-color: whitesmoke; */
    padding: 0 10px;
  }

  .yt-cell-view {
    height: 40px;
    line-height: 40px;
    color: #333333;
    font-size: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/module/multi-selector.vue